import MediaCard from './MediaCard'
import getStyles from './getStyles'

export default MediaCard
export {
  getStyles,
}
